module.exports = __webpack_public_path__ + "static/img/hotservice.60237afb.png";